export default [
    {
        header: "คอลบาเด้นท์", items: [

            { name: "ยาสีฟันคอลบาเด้นท์ ขนาด 35 กรัม" },
            { name: "ยาสีฟันคอลบาเด้นท์ ขนาด 100 กรัม" },
            { name: "ยาสีฟันคอลบาเด้นท์ ขนาด 160 กรัม" },
            { name: "นํ้ายาบ้วนปากคอลบาเด้นท์ ขนาด 250 มิลลิลิตร" },
            { name: "นํ้ายาบ้วนปากคอลบาเด้นท์ ขนาด 500 มิลลิลิตร" },
            { name: "ยาสีฟันคอลบาเด้นท์ คิดส์ ฮอกไกโด เมล่อน" },
            { name: "ยาสีฟันคอลบาเด้นท์ คิดส์ มิกซ์ เบอร์รี่" },
        ]
    },
    {
        header: "ไอโอเดิมร์",
        items: [

            { name: "แป้งเย็นไอโอเดิมร์ คลาสสิค คูลลิ่ง (สีฟ้า)" },
            { name: "แป้งเย็นไอโอเดิมร์ สวีต ซีเคร็ต (สีชมพู)" },
            { name: "สบู่เย็นอนามัยไอโอเดิมร์" },
            { name: "สบู่ไอโอเดิมร์ รอยัลมิลค์" },
            { name: "สบู่ไอโอเดิมร์ อะโวคาโด" },
            { name: "สบู่ไอโอเดิมร์ โอลีฟออย" },
            { name: "สบู่ไอโอเดิมร์ พอมมาเกรเนต" },
            { name: "ยาสีฟันไอโอเดิมร์ เฮิร์บ" },
            { name: "ยาสีฟันไอโอเดิมร์ แบมบู ซอลต์" },
        ]
    },
    {
        header: "กัมอะไลฟ์"
        , items: [

            { name: "ยาสีฟันกัมอะไลฟ์ สเปเชียล กัมแคร์ (GumAlive Special Gum Care)" },
            { name: "ยาสีฟันกัมอะไลฟ์ เฟรชเบรธ(GumAlive  Fresh Breath)" },
            { name: "ยาสีฟันกมอะไลฟ์ เนเชอรัลไวท์เทนนิ่ง(GumAlive Natural Whitening)" },
        ]
    },
]



// WEBPACK FOOTER //
// ./src/assets/js/sahapanproducts.js